import { HYDRATE } from 'next-redux-wrapper';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum CMSConfigIdActions {
  SLICE_NAME = '@APP/CMS_CONFIG_ID',
  SET_CMS_CONFIG_ID = '@APP/CMS_CONFIG_ID/setCMSConfigId'
}

export const INITIAL_CMS_CONFIG_ID_STATE: string = '';

const cmsConfigIdSlice = createSlice({
  name: CMSConfigIdActions.SLICE_NAME,
  initialState: INITIAL_CMS_CONFIG_ID_STATE,
  reducers: {
    setCMSConfigId: (state, action: PayloadAction<string>) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state: string = INITIAL_CMS_CONFIG_ID_STATE, action: any) => {
      if (action.payload?.app?.cmsConfigId !== state) {
        return action.payload?.app?.cmsConfigId || state;
      }
      return state;
    });
  }
});

export const { setCMSConfigId } = cmsConfigIdSlice.actions;
export const cmsConfigIdReducer = cmsConfigIdSlice.reducer;
